export interface ProviderFile {
    fileName: string;
    updatedAt: Date;
    fileUrl: string;
    documentType: string;
}

export interface Tier {
    tierId: number;
    tierName: string;
    sequence: number;
}

export interface Status {
    statusId: number;
    statusName: string;
    statusCode: string;
    sequence?: number;
}

export interface TierQuestions {
    tierId: number;
    tierName: string;
    performanceAreas: PerformanceArea[];
}


export interface Question {
    questionId: number;
    questionTitle: string;
    questionDescription: string;
    questionNumber: number,
    questionSequence: number,
    dataFieldType: string
    isReviewed: boolean | null;
    reviewResponseId: number | null | undefined;
    dataSource: string;
    isCalculatedField: boolean;
    displayConfig: DisplayConfig;
    responseData: QuestionResponse[];
    comment?:string | null;
    attachments?:DisputeAttachment[] | null;
}

export interface DisputeAttachment{
   
    FileName:string;
    FilePath: string;
    ErrorMessage: string;
    FileSequence: number;
}

export interface DisplayConfig {
    canHide: boolean;
}
export interface QuestionResponse {
    fieldName: string
    fieldValue: string,
    hasValidThreshold: boolean | null | undefined
    propertySequence: number | null | undefined
}

export interface Measure {
    reviewResponseId: number | null | undefined;
    measureId: number;
    measureTitle: string;
    measureDescription: string;
    measureNumber: string;
    reviewResponse: string | null;
    questions: Question[];
    isCommentsAvailable: boolean;
    hasReasons: boolean;
}

export interface Standard {
    standardId: number;
    standardTitle: string;
    standardDescription: string;
    isLocationSpecific: boolean;
    tierId: number;
    tierName: string;
    measures: Measure[];
}

export interface PerformanceArea {
    performanceAreaId: number;
    performanceAreaTitle: string;
    performanceAreaDescription: string;
    standards: Standard[];
}

export interface ReviewRquest {
    tierId: number;
    reviewResponseId: number | null | undefined;
    mpiId: string
    incentiveTypeId: number;
    questionId: number;
    reviewResponse: string | null;
    reasons: any[]|null;
    userReason: string | null;
    reviewerName: string | null | undefined;
}



export enum ReviewStatusCode {
    ReviewCompleted = "REVDONE",
    InPeerReview = "INPEERREV",
    NotStarted = "NOSTART",
    DocumentsNeeded = "DOCNEED",
    InPrimaryReview = "INPRMREV",

    //sco codes
     ScoNotStarted = "SCO-NOSTART",
    ScoInitialReview = "SCO-INITIALREV",
    ScoSMEReview = "SCO-SMEREV",
    ScoFinalReview = "SCO-FNLREV",
    ScoReviewCompleted = "SCO-REVDONE",

        //sco dispute
    ScoPfpResolutionNotStarted = "SCO-RES-NOSTART",
    ScoPfpResolutionInitialReview = "SCO-RES-INITIALREV",
    ScoPfpResolutionSMEReview = "SCO-RES-SMEREV",
    ScoPfpResolutionFinalReview = "SCO-RES-FNLREV",
    ScoPfpResolutionReviewCompleted = "SCO-RES-REVDONE",
}



export enum TierCode {
    NotEligible = "NOTELIGIBLE",
    Primary = "PRIMARY",
    Select = "SELECT",
    ClinicallyEnhanced = "CLINICALLYENHANCED",
    Conditional = "CONDITIONAL",
    UnAssigned = "UNASSIGNED",
    ScoUnAssigned = "SCO-UNASSIGNED",
    Active = "ACTIVE",
    ScoConditional = "SCO-CONDITIONAL"
}





export enum DataSource {
    CLS = "cls",
    EIM = "eim",
    HCSIS = "hcsis",
    HRST = "hrst",
}


export interface Provider {
    providerId: number;
    providerAgencyName: string;
    mpi: string;
    firstName: string;
    lastName: string;
    telephoneNumber: string;
    emailAddress: string;
    status: string;
    appliedTier: string;
    dateOfTierAssignment: Date | null;
    currentTier: string;
    reviewStatus: string;
    tierChangeStatus: string;
}



export function alphaNumericSort(a: string, b: string) {
    if (a == null) return -1;
    if (b == null) return 1;
    return a.localeCompare(b, 'en', { numeric: true });
}

export interface Comment {
    commentAddedBy: string;
    createdDate: string;
    commentDescription: string;
    commentId: number;
    measureId: number;
}
export interface KeyValue {
    key: string;
    value: any;
}


export enum ReviewType {
    PrimaryReview = "primary review",
    SecondaryReview = "secondary review",
}

export enum ProviderType{
    RH="RH",
    SCO="SCO"
}

export enum ReviewState {
     NOTSTART = "NOTSTART",
    INPROGRESS = "INPROGRESS",
    COMPLETED = "COMPLETED"
}
    
export interface PredefinedReason {
    reasonId: number;
    reasonText: string;
}
export interface ReviewReasonResponse {
    incentiveTypeId: number;
    userReason: string | null;
    predefinedReasons: PredefinedReason[];    
}

export interface ProjectConfiguration {
    projConfigId: number;
    projCategoryId: number;
    configKey: string
    configValue: string | null;
    isActive: boolean|null;
}
